module.exports = __webpack_public_path__ + "static/img/WILL-ROWLANDS.700817f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-ROWLANDS.jpg
// module id = 1UJ6
// module chunks = 0